export default "__VITE_ASSET__ec35014e__"